(() => {
  if (window.ArchiveCommunityRating) return;

  const isEnabled = value => value === true || value === 'true';
  const SCORE_PATTERN = /^\s*(\d+(?:\.\d+)?|\.\d+)\s*(?:\/\s*100)?\s*$/;

  const format = (value, enabled) => {
    if (!isEnabled(enabled) || value === null || value === undefined || String(value).trim() === '') return null;
    const match = String(value).match(SCORE_PATTERN);
    if (!match) return null;

    const numericValue = Number(match[1]);
    return Number.isFinite(numericValue) && numericValue >= 0 && numericValue <= 100
      ? numericValue.toFixed(1)
      : null;
  };

  const create = (value, enabled) => {
    const displayValue = format(value, enabled);
    if (displayValue === null) return null;

    const badge = document.createElement('span');
    badge.className = 'archive-community-rating';
    badge.setAttribute('role', 'img');
    badge.setAttribute('aria-label', `Whiskybase community rating ${displayValue} out of 100`);

    const score = document.createElement('span');
    score.className = 'archive-community-rating__score';
    score.setAttribute('aria-hidden', 'true');
    score.textContent = displayValue;

    const source = document.createElement('span');
    source.className = 'archive-community-rating__source';
    source.setAttribute('aria-hidden', 'true');
    source.textContent = 'Whiskybase';

    badge.append(score, source);
    return badge;
  };

  const markup = (value, enabled, modifier = '') => {
    const displayValue = format(value, enabled);
    if (displayValue === null) return '';
    const modifierClass = modifier === 'compact' ? ' archive-community-rating--compact' : '';
    return `<span class="archive-community-rating${modifierClass}" role="img" aria-label="Whiskybase community rating ${displayValue} out of 100"><span class="archive-community-rating__score" aria-hidden="true">${displayValue}</span><span class="archive-community-rating__source" aria-hidden="true">Whiskybase</span></span>`;
  };

  window.ArchiveCommunityRating = Object.freeze({ create, format, markup });
})();
